// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCardStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListProductCard";
import { color, customBadgesStyles, ellipsis, sharedProductDescriptionStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 116px minmax(0, 1fr) 330px;
        grid-column-gap: 12px;
        width: 100%;
    `,
};

productCardStyles.actionsGridItem = {
    css: css`
        padding-left: 12px;
        border-left: 1px solid ${color("common.border")};
    `,
};

productCardStyles.leftColumnGridItem = {};

productCardStyles.productListProductImage = {
    productImage: {
        linkWrappingImage: {
            css: css`
                aspect-ratio: 1;
                justify-content: center;
            `,
        },
        img: {
            css: css`
                ${ellipsis(5)};
            `,
        }
    },
};

productCardStyles.productListProductInformation = {
    container: { gap: 8 },
    descriptionGridItem: { width: 12 },
    descriptionStyles: { ...sharedProductDescriptionStyles() },
    partNumbersGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
            gap: 2px;
        `,
    },
    availabilityGridItem: { width: 6 },
    badgesContainerStyle: {
        width: 12,
        css: css`
            ${customBadgesStyles.container.css}
            gap: 8px;
        `,
    },
};
